import { useState, useEffect } from "react";
import {
  Facebook,
  EnvelopeAt,
  Instagram,
  Youtube,
} from "react-bootstrap-icons";

import logo from "./logo.png";
import { Contacts, Header, Logo, Wrapper, LinksWrapper } from "./App.styled";
import IconButton from "./components/IconButton";
import Player from "./components/Player";

function App() {
  const [isAlbum, setIsAlbum] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const album = params.has("album");
    setIsAlbum(album);

    if (window.gtag) {
      window.gtag("event", "qr_landing", {
        qr_variant: album ? "album" : "none",
        page_location: window.location.href,
      });
    }
  }, []);

  return (
    <Wrapper>
      <Header>
        {isAlbum && <Player />}

        <Logo src={logo} alt="GFAP" />
        <LinksWrapper>
          <IconButton
            icon={<Facebook />}
            label="facebook"
            link="https://www.facebook.com/gfarquitecturaporto"
            hoverColor="#1877F2"
          />
          <IconButton
            icon={<Instagram />}
            label="instagram"
            link="https://www.instagram.com/gfadosarquitectura/"
            hoverColor="#c13584"
          />
          <IconButton
            icon={<Youtube />}
            label="youtube"
            link="https://www.youtube.com/@GFADOSARQUITECTURA"
            hoverColor="#FF0000"
          />
          <IconButton
            icon={<EnvelopeAt />}
            label="email"
            link="mailto:gfarquitecturaup@gmail.com"
            hoverColor="grey"
          />
        </LinksWrapper>

        <Contacts>
          <a href="tel:+351961872780">961 872 780</a>
          <br />
          Via Panorâmica 215
          <br />
          Porto, Portugal, 4150-140
        </Contacts>
      </Header>
    </Wrapper>
  );
}

export default App;
